import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import {  SectionHeading, SectionSubHeading, SectionWrapper } from "../../../Styles/style";
import aboutimg from "../../../../assets/images/aboutimg.png"
import { BuyNow } from "../S1_Header/styles";
import { useTheme } from "@emotion/react";
import image from "../../../../assets/images/back.png"
const SectioncardHeading = styled.h1`
font-family: "digit";
text-transform:uppercase;
  font-size: ${(props) => (props.fs ? props.fs : "50px")};
  color: ${(props) => props.theme.textPrimary};
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  /* line-height: ${(props) => (props.lh ? props.lh : "50px")}; */
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "center")};
  @media screen and (max-width: 1199px) {
    font-size: 40px;
  }
  @media (max-width: 599px) {
    font-size: ${(props) => (props.fs599 ? props.fs599 : "40px")};
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
  @media (max-width: 399px) {
    font-size: ${(props) => (props.fs399 ? props.fs399 : "25px")};
    padding: ${(props) => (props.p399 ? props.p399 : "")};
  }
`;
const P = styled.p`
background-image: url(${image});
// background-color:#222222;
background-size: 100% 100%;
  font-weight: ${(props) => (props.fw ? props.fw : "")};
  font-family: "consol";
  font-size: ${(props) => (props.fs ? props.fs : "18px")};
  color: ${(props) => (props.color ? props.color : props.theme.textPrimary)};
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : "")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin: ${(props) => (props.m ? props.m : "20px 0")};
  padding: 40px;
  display: ${(props) => (props.display ? props.display : "")};
  justify-content: ${(props) => (props.jc ? props.jc : "")};
  // border: 5px solid #00FF00;
  // border-radius: 20px;
  height:100%;
  min-height: 467px;
  @media (max-width: 600px) {
    font-size: ${(props) => (props.fs600px ? props.fs600px : "")};
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;
const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const GridImagecenter = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
text-align-last: center;

`;
const JOiningLinks = styled.img`
  width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "450px")};
  @media screen and (max-width:599px){
   /* max-width: ${(props) => (props.mw ? props.mw : "140PX")}; */

 }
`
const FeatureWrapper = styled.div`
 background: #151515;GridImage
  text-align:center;
border-radius:20px;
  padding: 20px;
  height:440px;
  
  @media screen and (max-width:499px){
  height: 550px;

 }
`
const Wrap = styled.div`

background-size: cover;
background-repeat: no-repeat;
background-position:center;
    min-height: 506px;
    display: flex;
    align-items: center;
    padding:40px 30px;
    border-radius:30px;
    @media screen and (max-width:499px){
/* margin:0 0 0 20px; */

 }

`
const S2_Aboutus = () => {
  const theme = useTheme()
  return (
    <div>
      <SectionWrapper bgColor="#000" p="2rem 0 0" p799="0" p599="0" id="About">
        <Container maxWidth="xl">

          <GridHEading container columnSpacing={2} rowSpacing={3}>
          <GridImage item xs={12} md={12}
              data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-duration="600"
              data-aos-offset="0"
            >
              <SectionHeading
                fs="70px"
                p="30px 0"
                m="0"
                align="center"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
                style={{textAlign:'center',paddingBottom:'0'}}
              >Why Choose $Shib
              </SectionHeading></GridImage>
            <GridImage item xs={12} md={2.5}
              data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-duration="600"
              data-aos-offset="0"
            >
              <SectioncardHeading
                fs="30px"
                p="30px 0"
                m="0"
                align="center"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
              >Bot-Free
              </SectioncardHeading>


              <P align="LEFT"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
            Say goodbye to bot
            interference! The Pulse
            Network provides a safe and
            secure environment, free from
            bots, ensuring genuine
            engagement and fair
            transactions for Shib holders.
               </P>
              {/* <BuyNow >OTC TG Group</BuyNow> */}



            </GridImage>
            <GridImage item xs={12} md={0.65}></GridImage>
            <GridImage item xs={12} md={2.5}
              data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-duration="600"
              data-aos-offset="0"
            >
              <SectioncardHeading
                fs="30px"
                p="30px 0"
                m="0"
                align="center"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
              >Community
              </SectioncardHeading>


              <P align="LEFT"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
             Become part of our dynamic
Shib community on the Pulse
Network. Join forces with fellow
enthusiasts, collaborate on
exciting initiatives, and unlock
endless possibilities together.
               </P>
              {/* <BuyNow >OTC TG Group</BuyNow> */}



            </GridImage>
            <GridImage item xs={12} md={0.65}></GridImage>

            <GridImage item xs={12} md={2.5}
              data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-duration="600"
              data-aos-offset="0"
            >
              <SectioncardHeading
                fs="30px"
                p="30px 0"
                m="0"
                align="center"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
              >Technology
              </SectioncardHeading>


              <P align="LEFT"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
            Harness the power of advanced
technology on the Pulse
Network. Experience lightning-
fast, scalable transactions that
make Shib a seamless and
efficient digital currency. 
               </P>
              {/* <BuyNow >OTC TG Group</BuyNow> */}



            </GridImage>
            <GridImage item xs={12} md={0.65}></GridImage>

            <GridImage item xs={12} md={2.5}
              data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-duration="600"
              data-aos-offset="0"
            >
              <SectioncardHeading
                fs="30px"
                p="30px 0"
                m="0"
                align="center"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
              >Potential
              </SectioncardHeading>


              <P align="LEFT"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
            Position yourself at the
forefront of a groundbreaking
movement. With Shib on the
Pulse Network, you have the
opportunity to be part of
exponential growth and
innovation in the Shiba Inu coin
ecosystem.
               </P>
              {/* <BuyNow >OTC TG Group</BuyNow> */}



            </GridImage>
          </GridHEading>

        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S2_Aboutus;
